import React from 'react'
import { Loading } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { Card } from './components/Card'
import { useStyles } from './styles'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'
import { useGetDashboard } from 'src/hooks/api/dashboard'

export const Dashboard: React.FC = () => {
  const { data: dashboardData = [], isLoading, isError, isFetching, refetch } = useGetDashboard()
  const style = useStyles()

  const [data] = dashboardData

  return (
    <>
      <div className={style.propertiesHeader}>
        <PageTitle title='Dashboard' />
      </div>

      {isLoading || isFetching || isError ? (
        <Loading refetch={refetch} isError={isError} />
      ) : (
        <>
          <div className={style.dashboardContainerContent}>
            <div className={style.dashboardCardsContainer}>
              <Swiper
                modules={[Pagination]}
                pagination={{ clickable: true }}
                spaceBetween={16}
                breakpoints={{
                  320: {
                    slidesPerView: 1
                  },
                  480: {
                    slidesPerView: 2
                  },
                  640: {
                    slidesPerView: 3
                  }
                }}
              >
                <SwiperSlide>
                  <Card type='registered' label='Machos cadastrados' value={data.totalMachos} />
                </SwiperSlide>
                <SwiperSlide>
                  <Card type='births' label='Fêmeas cadastradas' value={data.totalFemeas} />
                </SwiperSlide>
                <SwiperSlide>
                  <Card type='roof' label='Total de animais' value={data.totalFemeas! + data.totalMachos!} />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </>
      )}
    </>
  )
}
